import { addSlidesTabIndex } from '../../../../../gravity-global/assets/js/helpers/swiper/add-slides-tab-index';

const relatedInsightsManualInit = () => {
    document
        .querySelectorAll('.gg-related-insights-manual .wp-block-statik-slider > .swiper')
        /* eslint-disable */
        .forEach((clientLogosCarousel) => {
            clientLogosCarousel.swiper.params.spaceBetween = 30;
            clientLogosCarousel.swiper.params.breakpoints = {
                /* eslint-enable */
                0: {
                    slidesPerView: 1,

                },
                640: {
                    slidesPerView: 3,

                },
            };
            addSlidesTabIndex(clientLogosCarousel.swiper);

            clientLogosCarousel.swiper.on('slideChange', () => {
                addSlidesTabIndex(clientLogosCarousel.swiper);
            });

            clientLogosCarousel.swiper.update();
        });
};

document.addEventListener('DOMContentLoaded', () => {
    relatedInsightsManualInit();
});
